/* eslint-disable react/no-danger */
/* eslint-disable import/extensions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
} from 'semantic-ui-react';
import marked from 'marked';

class NotificationItem extends Component {
  constructor(props) {
    super(props);

    const item = props.item || {};

    let msg = props.item.message || '';
    if (props.message) {
      msg = props.message;
    }

    this.state = {
      msg,
      item,
    };
  }
  componentWillReceiveProps(nextProps) {
    const item = nextProps.item || {};
    let msg = nextProps.item.message || '';
    if (nextProps.message) {
      msg = nextProps.message;
    }
    this.setState({
      msg,
      item,
    });
  }
  primaryColumnSize = () => {
    if (this.props.leftComponent) {
      return 'col-xs-7 col-md-9 col-lg-7';
    }
    return 'col-xs-9 col-md-10';
  }
  innerHtml() {
    return { __html: marked.parse(this.state.msg) };
  }
  render() {
    marked.setOptions({ sanitize: true });
    const classNames = ['list-item', 'notification-item'];
    if (this.props.className) {
      classNames.push(this.props.className);
    }
    if (this.props.selected) {
      classNames.push('selected');
    }
    if (this.props.disabled) {
      classNames.push('disabled');
    }
    return (
      <div
        className={classNames.join(' ')}
      >
        <Grid>
          <Grid.Row>
            {
              this.props.leftComponent ?
                <Grid.Column mobile={2} tablet={1} computer={1} textAlign="center" verticalAlign="middle" style={{ padding: '0' }}>
                  {this.props.leftComponent}
                </Grid.Column>
                : null
            }
            <Grid.Column mobile={14} tablet={15} computer={15} textAlign="left" verticalAlign="middle" style={{ padding: '0' }}>
              <small style={{ marginLeft: '0.5em' }}><i>{this.props.timestamp}</i><br /></small>
              <div
                dangerouslySetInnerHTML={this.innerHtml()}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div >
    );
  }
}

NotificationItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  leftComponent: PropTypes.node,
  timestamp: PropTypes.object,
  url: PropTypes.string,
  message: PropTypes.string,
  disabledOnClick: PropTypes.func,
};

NotificationItem.contextTypes = {
  store: PropTypes.object,
};

export default NotificationItem;



// WEBPACK FOOTER //
// ./src/components/Bookings/LeadActivity/NotificationItem.jsx